import React, { Component } from 'react';
import AppSidebar from "../components/AppSidebar";
import PageHeader from "../components/PageHeader";
import ActionButton from "../components/ActionButton";
import PanelGroupController from "../components/PanelGroupController";
import FilterPanel from "../components/panels/FilterPanel";
import SearchQueriesPanel from "../components/panels/SearchQueriesPanel";
import EdiMessagePropertiesPanel from "./panels/EdiMessagePropertiesPanel";
import EdiMessagesList from "./views/EdiMessagesList";
import {requestViewEdiMessageData} from "../actions/ShippingApiActions";
import {connect} from "react-redux";
import {Map, List, fromJS} from "immutable";

const statusFilterOptions = fromJS([
  {id: "", label: "All"},
  {id: "processed", label: "Processed"},
  {id: "invalid_or_failed", label: "Invalid or Failed"},
  {id: "deleted", label: "Deleted"}
])

const searchOptions = fromJS([
  {prop: "orderId", label: "Order Id", type: "string"},
  {prop: "filename", label: "Filename", type: "string"}
])


class EdiMessagesPage extends Component {

  constructor(props) {
    super(props);
    this.handleSetSelection = this.handleSetSelection.bind(this);
    this.handleViewData = this.handleViewData.bind(this);
    this.state = {
      selectedId: "",
      statusFilter: "invalid_or_failed",
      hasSelection: false,
    }
  }


  render() {
    const page = this.props.route.page;
    let view = this.renderView(page);
    let panels = this.renderPanels(page);

    let title = "Incoming EDI Message Queue";

    return (
      <div className="ShippingPage EdiMessagesPage SecurePage">
        <AppSidebar />
        <PageHeader title={title} />
        <div className="PageContainer">
          {view}
        </div>
        <div className="PanelContainer">
          <div className="header" />
          {panels}
          <PanelGroupController title="Actions">
            <ActionButton 
              label="View data" 
              active={this.state.hasSelection}
              onClick={this.handleViewData}
              />          
          </PanelGroupController>
        </div>
      </div>
    );
  }

  renderView(page) {
    let searchQueries = Map(this.props.router.location.query);
    switch(page) {
      default: 
        return <EdiMessagesList
                key="EdiMessagesList"
                kind={this.state.filter}
                selectedId={this.state.selectedId}
                onSelectionChange={this.handleSetSelection}
                statusFilter={this.state.statusFilter}
                orderIdSearch={searchQueries.get("orderId", "")}
                filenameSearch={searchQueries.get("filename", "")}
                />
    }
  }


  renderPanels(page) {
    switch(page) {
      default:
        return this.buildPanels(List([SearchQueriesPanel, "statusFilter", EdiMessagePropertiesPanel]));
    }
  }

  buildPanels(panels) {
    return panels.map(x => this.buildPanel(x));
  }

  buildPanel(component) {
    switch(component) {
      case EdiMessagePropertiesPanel:
        return <EdiMessagePropertiesPanel
                id={this.state.selectedId}
                />

      case "statusFilter":
        return <FilterPanel
          key="StatusFilterPanel"
          title="Status Filter"
          expanded={true}
          options={statusFilterOptions}
          onClick={this.handleSetStatusFilter.bind(this)}
          filter={this.state.statusFilter}
          />        

      case SearchQueriesPanel:
        return <SearchQueriesPanel
                key="SearchQueriesPanel"
                expanded={true}
                properties={searchOptions}
                query={Map(this.props.router.location.query)}
                onChange={this.handleSearchParamChange.bind(this)}
                onClear={this.handleSearchClear.bind(this)}
                />

      default:
        return null;
    }
  }

  handleSetSelection(item) {
    this.setState({
      hasSelection: true,
      selectedId: item.get("id"),
    })
  }

  handleSetStatusFilter(item) {
    this.setState({
      statusFilter: item.get("id")
    });
  }  

  handleSearchParamChange(prop, value) {
    let searchQueries = Map(this.props.router.location.query)
    if (value === "") {
      searchQueries = searchQueries.delete(prop)
    } else {
      searchQueries = searchQueries.set(prop, value);
    }
    this.props.router.push({
      pathname: "/shipping/edi",
      query: searchQueries.toJS()
    });    
  }

  handleSearchClear() {
    let searchQueries = Map(this.props.router.location.query);
    let searchOptionKeys = searchOptions.map((val) => val.get("prop"));
    let emptySearchQueries = searchOptionKeys.reduce((acc, key) => {
      return acc.delete(key);
    }, searchQueries);

    this.props.router.push({
      pathname: "/shipping/edi",
      query: emptySearchQueries.toJS()
    });
  }    

  handleViewData() {
    this.props.requestViewEdiMessageData(this.state.selectedId);
  }

}


export default connect(null, {requestViewEdiMessageData})(EdiMessagesPage);